import { Tag } from "primereact/tag";

import { SelectableCard } from "@/ds";

import {
  EM_CONFLITO_LABEL,
  ESCOPO_SECTION_LABEL,
  OBRA_SECTION_LABEL,
  SEM_CONFLITO_LABEL,
} from "../../resolver-conflito-fornecedor.constants";
import styles from "./escopos-fornecedor-step.module.scss";
import type { EscoposFornecedorStepViewModel } from "./types-escopos-fornecedor-step";

export function EscoposFornecedorStepView({
  fornecedorNome,
  sobreposicao,
  obras,
  erroObra,
  escopos,
  escopoResumo,
  escolherObra,
  escolherEscopo,
}: EscoposFornecedorStepViewModel) {
  return (
    <>
      <div className={styles.resumo} data-testid="resolver-conflito-resumo-curto">
        <span>
          <strong>{fornecedorNome}</strong> • Fornecedor
        </span>
        <span className={styles.resumoInfo}>
          <i className="pi pi-info-circle" aria-hidden />
          {sobreposicao}
        </span>
      </div>

      <fieldset className={styles.secao} aria-describedby="resolver-conflito-obra-error">
        <legend className={styles.secaoTitulo}>{OBRA_SECTION_LABEL}</legend>
        <div className={styles.opcoes}>
          {obras.map((obra) => (
            <SelectableCard
              key={obra.id}
              value={obra.id}
              selected={obra.marcada}
              name="resolver-conflito-obra"
              onSelect={escolherObra}
              className={erroObra ? styles.invalida : undefined}
              data-testid="resolver-conflito-obra-option"
            >
              <span className={styles.opcaoCorpo}>
                <span className={styles.opcaoTitulo}>{obra.titulo}</span>
                <span className={styles.opcaoMeta}>
                  <i className="pi pi-user" aria-hidden />
                  {obra.meta}
                </span>
              </span>
            </SelectableCard>
          ))}
        </div>
        {erroObra ? (
          <span
            id="resolver-conflito-obra-error"
            className={styles.erro}
            role="alert"
            data-testid="resolver-conflito-obra-error"
          >
            {erroObra}
          </span>
        ) : null}
      </fieldset>

      {escopos ? (
        <fieldset className={styles.secao} data-testid="resolver-conflito-escopos">
          <legend className={styles.secaoTitulo}>{ESCOPO_SECTION_LABEL}</legend>
          <div className={styles.opcoes}>
            {escopos.map((escopo) => (
              <SelectableCard
                key={escopo.id}
                value={escopo.id}
                selected={escopo.marcado}
                name="resolver-conflito-escopo"
                onSelect={escolherEscopo}
                className={styles.escopo}
                data-testid="resolver-conflito-escopo-option"
              >
                <span className={styles.opcaoCorpo}>
                  <span className={styles.opcaoTitulo}>{escopo.titulo}</span>
                  <span className={styles.opcaoMeta}>{escopo.meta}</span>
                </span>
                <Tag
                  className="p-tag-xs"
                  severity={escopo.emConflito ? "warning" : "secondary"}
                  value={escopo.emConflito ? EM_CONFLITO_LABEL : SEM_CONFLITO_LABEL}
                />
              </SelectableCard>
            ))}
          </div>
          {escopoResumo ? (
            <p className={styles.dica} data-testid="resolver-conflito-escopo-resumo">
              <i className="pi pi-check" aria-hidden />
              {escopoResumo}
            </p>
          ) : null}
        </fieldset>
      ) : null}
    </>
  );
}
